import { ArmorEnum, Defines, type IEntityData } from "../../defines";
/**
 *
 * @todo
 * @export
 * @param {IEntityData} data
 * @return {IEntityData} 
 */
export function make_fighter_data_knight(data: IEntityData): IEntityData {
  data.base.armor = {
    hit_sounds: ["data/085.wav.mp3"],
    type: ArmorEnum.Defend,
    toughness: 60,
    toughness_resting: 18,
  };
  return data;
}
